<script>
import { defineComponent } from "vue";
import { onMessage } from "firebase/messaging";
import { messaging } from "@/composables/firebase/firebase";

export default defineComponent({
  name: "PushNotification",
  data() {
    return {
      snack: false,
      message: "",
      snackColor: "success"
    };
  },
  methods: {
    getSnackColor(type) {
      switch (type) {
        //仮受注データ新規作成
        case "new":
          return "success";
        //仮受注データ更新
        // case "update":
        //   return "info";
        //仮受注データ削除
        // case "delete":
        //   return "warning";
        //仮受注受注希望者データ新規作成
        case "newApplicant":
          return "primary";
        //仮受注受注希望者データ削除
        case "deleteApplicant":
          return "yellow darken-3";
        //仮受注データ正式受注確定
        case "confirmOrder":
          return "blue lighten-3";
        //受注登録中
        case "creatingOrder":
          return "warning";
        //受注登録キャンセル
        case "creatingOrderCancel":
          return "yellow darken-3";
        default:
          return "error";
      }
    }
  },

  mounted() {
    if (messaging) {
      // フォアグラウンドで受信した際のリスナー設定
      onMessage(messaging, payload => {
        console.log("Message received while app is in foreground. ", payload);
        this.message = payload.notification.title + "\n" + payload.notification.body;
        this.snackColor = this.getSnackColor(payload.data.messageType);
        this.snack = true;
      });
    }
  }
});
</script>

<template lang="pug">
  v-snackbar(v-model="snack" :color="snackColor" :timeout="6000" multi-line)
    div
      span.whitespace-pre {{ message }}
      v-btn(flat icon dark @click="snack = false")
        v-icon close
</template>

<style scoped lang="stylus"></style>
